module.exports = __webpack_public_path__ + "static/media/big-grey-cross.670e5a38.svg";